import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getTagsForPerson, getTagsForOrder } from './tagsThunk';
import { TagsState, Tag } from './types';
import { CustomError } from 'shared/api';

const initialState: TagsState = {
	tagsForPerson: [],
	tagsForOrder: [],
	loading: false,
	error: null,
};

const tagsSlice = createSlice({
	name: 'tags',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(getTagsForPerson.pending, state => {
				state.loading = true;
				state.error = null;
			})
			.addCase(
				getTagsForPerson.fulfilled,
				(state, action: PayloadAction<Tag[]>) => {
					state.tagsForPerson = action.payload;
					state.loading = false;
				},
			)
			.addCase(getTagsForPerson.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload as CustomError;
			})
			.addCase(getTagsForOrder.pending, state => {
				state.loading = true;
				state.error = null;
			})
			.addCase(
				getTagsForOrder.fulfilled,
				(state, action: PayloadAction<Tag[]>) => {
					state.tagsForOrder = action.payload;
					state.loading = false;
				},
			)
			.addCase(getTagsForOrder.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload as CustomError;
			});
	},
});

export const { actions, reducer } = tagsSlice;
export const tagsReducer = reducer;
